module.exports = __webpack_public_path__ + "static/media/recipeShelf.a9658ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/recipeShelf.jpg
// module id = 82
// module chunks = 0